<template>
  <tk-container :status="status">
    <!-- 内容区域 -->
    <tk-flex middle class="w-full h-full p-15">
      <div class="w-full">
        <QuestionContent
          v-if="question"
          :question="question"
          :is-fullscreen="isFullscreen"
          :compact="true"
          @complete="handleComplete"
        />
      </div>
    </tk-flex>
  </tk-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import QuestionContent from '@/components/QuestionContent.vue'

export default {
  components: {
    QuestionContent
  },
  data() {
    return {
      status: 'loading',
      isFullscreen: false
    }
  },
  computed: {
    ...mapState({
      question: (state) => state.currentQuiz
    })
  },
  created() {
    if (!this.question) {
      this.$back()
      return
    }
    this.status = false
  },
  mounted() {
    this.updateOrientation()
    window.addEventListener('resize', this.updateOrientation)
    window.addEventListener('orientationchange', this.updateOrientation)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateOrientation)
    window.removeEventListener('orientationchange', this.updateOrientation)
  },
  methods: {
    ...mapMutations(['setQuizResult']),
    handleComplete(result) {
      this.setQuizResult(result)
      this.$back()
    },
    updateOrientation() {
      // 通过浏览器宽高判断横竖屏:宽度大于高度则为横屏(全屏)
      this.isFullscreen = window.innerWidth > window.innerHeight
    }
  }
}
</script>
